import { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
// react-query
import { useCategoryListGet, useGetFilterQuery } from 'hooks/queries/match';
import { useSetFilterMutation } from 'hooks/mutations/match';
// hooks
import useToast from 'hooks/useToast';
// components
import {
	SectionHeaderRow,
	StickySectionHeaderRow,
} from 'styles/styled-components/section';
import CoreGrayButton from 'shared/button/CoreGrayButton';
import CorePrimaryButton from 'shared/button/CorePrimaryButton';
import CoreSelect from 'shared/CoreSelect';
import style from 'styles/styled-components/style';
// store
import useCommonStore from 'store/useCommonStore';
// utils
import { filter_data_mapper, nameToCode } from 'utils/match/matchFilterData';
// type
import type { IIgFilter, INbFilter, IYtFilter, ITtFilter } from 'store/type';
import type { PlatformCode } from 'type/common';
import type { IFilter } from 'apis/match_apis';

const MatchFilterRow = () => {
	const navigate = useNavigate();

	// store
	const { platform, filter, setFilter, setPage } = useCommonStore();
	const platform_code = platform.code as PlatformCode;

	// toast
	const toast = useToast();

	// loading
	const [loading, setLoading] = useState({ reset: false, apply: false });

	// react-query
	useGetFilterQuery({
		onSettled() {
			setLoading({ reset: false, apply: false });
		},
	});
	const { mutate: filterMutate } = useSetFilterMutation();

	/** 필터 선택 함수를 반환하는 함수 (셀렉트 박스에 사용) */
	const _setSelectedFilter = (filter_name: string) => {
		const setSelectedFilter = (value: string) => {
			console.log('setSelectedFilter::::1', filter_name, value, platform.code);
			if (platform.code === null) return;

			const obj: IIgFilter | IYtFilter | INbFilter | ITtFilter = {
				...filter[`${platform.code}_filter`],
			};

			console.log('setSelectedFilter::::2', obj, obj[`${filter_name}`]);

			obj[`${filter_name}`] = value;

			console.log('setSelectedFilter::::3', obj, obj[`${filter_name}`]);

			setFilter(platform.code, obj as IIgFilter & IYtFilter & INbFilter & ITtFilter);
		};

		return setSelectedFilter;
	};

	/** 필터 초기화 */
	const resetFilter = () => {
		setLoading((state) => ({ ...state, reset: true }));
		const obj = { ...filter[`${platform_code}_filter`] };

		const obj_entries = Object.entries(obj).map((item) => {
			item[1] = 'all';
			return item;
		});

		const obj_filled_by_all = Object.fromEntries(obj_entries);

		filterMutate(obj_filled_by_all as IFilter, {
			onSuccess() {
				navigate('/imms/match?page=1');
				setPage(1);
			},
			onError() {
				setLoading({ reset: false, apply: false });
				toast('필터 초기화에 실패했습니다.');
			},
		});
	};

	/** 필터 적용 */
	const applyFilter = () => {
		setLoading((state) => ({ ...state, apply: true }));
		const obj_entries = Object.entries(filter[`${platform_code}_filter`]);

		const code_entiries = obj_entries.map((item) => {
			item[1] = nameToCode(platform_code, item[0], item[1]);
			return item;
		});

		const result_obj = Object.fromEntries(code_entiries);

		filterMutate(result_obj as IFilter, {
			onSuccess() {
				navigate('/imms/match?page=1');
				setPage(1);
			},
			onError() {
				setLoading({ reset: false, apply: false });
				toast('필터 적용에 실패했습니다.');
			},
		});
	};

	const { data } = useCategoryListGet(platform?.code as PlatformCode, {
		enabled: Boolean(platform?.code),
		select(res) {
			return res?.categories?.map((item) => ({
				name: item.name,
				code: item.name,
			}));
		},
	});

	let filterData = platform?.code ? filter_data_mapper[platform.code] : [];
	filterData = filterData.map((item) => {
		if (item.label_code === 'categories' && data && item.list?.length <= 1) {
			return {
				...item,
				list: [...item.list, ...data],
			};
		} else return item;
	});

	console.log('selected', filter[`${platform_code}_filter`]?.['categories']);

	return (
		<StickySectionHeaderRow _padding="16px" sticky_top="73px">
			<style.Grid flex="between" align_items="end" _gap="8px">
				<SelectContainer>
					{platform.code &&
						// filter_data_mapper[platform.code].map((item, idx) => (
						filterData.map((item, idx) => (
							<SelectInner key={idx}>
								<CoreSelect
									select_type="box"
									label={item.label}
									default_quote="-"
									option_list={item?.list?.map((item) => item.name)}
									selected_option={
										filter[`${platform_code}_filter`][
											item.label_code as keyof (
												| IIgFilter
												| IYtFilter
												| INbFilter
												| ITtFilter
											)
										]
									}
									setSelectedOption={_setSelectedFilter(item.label_code)}
								/>
							</SelectInner>
						))}
					<ButtonContainer>
						<CoreGrayButton
							size="large"
							style_type="outlined"
							text="필터 초기화"
							_width="120px"
							_onClick={resetFilter}
							is_loading={loading.reset}
						/>
						<CorePrimaryButton
							size="large"
							style_type="filled"
							text="필터 적용"
							_width="110px"
							_onClick={applyFilter}
							is_loading={loading.apply}
						/>
					</ButtonContainer>
				</SelectContainer>
			</style.Grid>
		</StickySectionHeaderRow>
	);
};

const SelectContainer = styled.div`
	width: auto;
	${({ theme }) => theme.common.flexStart};
	align-items: flex-end;
	flex-wrap: wrap;
	gap: 8px;
	flex: 1 0;
`;

const SelectInner = styled.div`
	min-width: 176px;
	flex: 0 0;
`;

const ButtonContainer = styled.div`
	min-width: 220px;
	${({ theme }) => theme.common.flexEnd};
	gap: 8px;

	flex: 1 0;

	& > button {
		flex: 110px 0;
	}
`;

export default MatchFilterRow;
